import { render, staticRenderFns } from "./Agriculture.vue?vue&type=template&id=99f9b9ec&scoped=true&"
import script from "./Agriculture.vue?vue&type=script&lang=js&"
export * from "./Agriculture.vue?vue&type=script&lang=js&"
import style0 from "./Agriculture.vue?vue&type=style&index=0&id=99f9b9ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9b9ec",
  null
  
)

export default component.exports